export function headerSearch() {
    const headerMenu = $('.header-menu');
    const openSearchButton = $('.btn-search-open');
    const closeSearchButton = $('.btn-search-close');

    openSearchButton.on('click', function () {
        headerMenu.addClass('active');
    });

    closeSearchButton.on('click', function () {
        headerMenu.removeClass('active');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerSearch.js